import React from 'react';
import type { AccessibilityProps } from 'react-native';
import { StyleSheet } from 'react-native';
import type { ImageTransform } from 'cloudinary-tiny-js';

import { theme } from '@garnish/constants';
import { IllusEmpty_2 } from '../../../assets';
import { useResponsive } from '../../../hooks';
import { FallbackImage } from '../../Image';
import { Card } from '../../Card';

// ────────────────────────────────────────────────────────────────────────────────

export const LineItemImage = (props: ProductImageProps) => {
  const { cloudinaryImageUrl, accessibilityLabel, isDisabled, onPress } = props;

  const { match } = useResponsive();

  const isPressable = Boolean(!isDisabled && onPress);

  return (
    <Card
      onPress={isPressable ? onPress : undefined}
      accessibilityLabel={isPressable ? accessibilityLabel : undefined}
      accessibilityRole={isPressable ? 'imagebutton' : undefined}
      baseBackgroundColor={theme.colors.OATMEAL}
    >
      <FallbackImage
        baseUrl={cloudinaryImageUrl}
        defaultImage={IllusEmpty_2}
        testId="product-card-image"
        resizeMode="contain"
        style={match([styles.imgXS, styles.imgSM])}
        cloudinaryConfig={CLOUDINARY_CONFIG}
      />
    </Card>
  );
};

// ─── CONSTANTS ──────────────────────────────────────────────────────────────────

const CLOUDINARY_CONFIG: readonly ImageTransform[] = [
  { crop: 'crop', height: 0.57, width: 0.5, x: 0.25, y: 0.25 },
  { width: 120 },
];

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  imgXS: {
    width: 100,
    height: 75,
  },
  imgSM: {
    width: 120,
    height: 90,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type ProductImageProps = {
  readonly cloudinaryImageUrl: string;
  readonly isDisabled?: boolean;
  readonly onPress?: () => void;
} & Pick<AccessibilityProps, 'accessibilityLabel'>;
